// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__Mx5Xg","content":"Search_content__msRj2","title":"Search_title__eVnY3"};